export const saveAmountItemGroup = (values) => {
    return {
        type: 'SET_AMOUNT_ITEM_GROUP',
        payload: values
    }
};

